import { render, staticRenderFns } from "./location.vue?vue&type=template&id=621d36a5&scoped=true&"
import script from "./location.component.ts?vue&type=script&lang=ts&"
export * from "./location.component.ts?vue&type=script&lang=ts&"
import style0 from "./location.scss?vue&type=style&index=0&id=621d36a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621d36a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('621d36a5')) {
      api.createRecord('621d36a5', component.options)
    } else {
      api.reload('621d36a5', component.options)
    }
    module.hot.accept("./location.vue?vue&type=template&id=621d36a5&scoped=true&", function () {
      api.rerender('621d36a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/location/location.vue"
export default component.exports